import React, { useState, useEffect, useRef } from "react";

import { Image, VStack, SimpleGrid, Text, CloseButton, Button, Box, Menu, Input, Field } from "@chakra-ui/react";
import { LuFastForward, LuPause, LuPlay, LuTimer, LuX } from "react-icons/lu";
import { getCameraImageTypeName } from "../../../../../utilies/CameraImagesUtility";
import { floatingStyles, flyToLocation, selectEntityById } from "../../../../../utilies/Utility";
import Type from "../../../../../utilies/Types";
import { Cartesian3, Math as CesiumMath, SceneMode } from "cesium";
import { useAppStore } from "../../../../../context/store";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
const ImageGeojsonBoxes = () => {
  // ===== state =====
  const imageDataSource = useAppStore((s) => s.imageDataSource);
  const imageGeojson = useAppStore((s) => s.imageGeojson);
  const imageGeojsonMode = useAppStore((s) => s.imageGeojsonMode);
  const imageGeojsonSelected = useAppStore((s) => s.imageGeojsonSelected);
  const imageGeojsonCounter = useAppStore((s) => s.imageGeojsonCounter);
  const geojsonImageCamera = useAppStore((s) => s.geojsonImageCamera);
  const cameraImageAllAutoPalyTimeout = useAppStore((s) => s.cameraImageAllAutoPalyTimeout);
  const cameraImageAllAutoPalySkip = useAppStore((s) => s.cameraImageAllAutoPalySkip);
  const cameraImageAllAutoPaly = useAppStore((s) => s.cameraImageAllAutoPaly);
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();
  const camera = useAppStore((s) => s.camera);

  // ===== setters / refs =====
  const viewerRef = useAppStore.getState().viewerRef;
  const setImageGeojsonSelected = useAppStore.getState().setImageGeojsonSelected;
  const setImageGeojsonCounter = useAppStore.getState().setImageGeojsonCounter;
  const setGeojsonImageCamera = useAppStore.getState().setGeojsonImageCamera;
  const setIsOpenAddonsMenu = useAppStore.getState().setIsOpenAddonsMenu;
  const setCameraImageAllAutoPaly = useAppStore.getState().setCameraImageAllAutoPaly;
  const setBgImageUrl = useAppStore.getState().setBgImageUrl;
  const setImageGeojsonMode = useAppStore.getState().setImageGeojsonMode;
  const setCamera = useAppStore.getState().setCamera;

  const [fullscreenImage, setFullscreenImage] = useState(null);

  const [isPlay, setIsPlay] = useState(false);

  const [isShowPointCloudMenu, setIsShowPointCloudMenu] = useState(false);
  useEffect(() => {
    let isShow = false;
    if (mapObjects) {
      for (const key in mapObjects) {
        if (mapObjects[key].type == Type.ASSET.THREEDTILES) {
          isShow = true;
          break;
        }
      }
    }
    setIsShowPointCloudMenu(isShow);
  }, [mapObjects]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [imageGeojson, imageGeojsonCounter, imageGeojsonMode, fullscreenImage, imageGeojsonSelected]);

  useEffect(() => {
    let intervalId;

    if (cameraImageAllAutoPaly) {
      clearInterval(intervalId);

      intervalId = setInterval(() => {
        const geojson = geojsonRef.current;
        const counter = counterRef.current;
        const fullscreen = fullscreenRef.current;
        const cam = cameraRef.current;

        const step = parseInt(cameraImageAllAutoPalySkip) || 1;
        const nextIndex = counter + step;

        if (geojson && geojson.features[nextIndex]) {
          setImageGeojsonSelected(geojson.features[nextIndex]);
          setImageGeojsonCounter(nextIndex);
          counterRef.current = nextIndex;

          const allEntities = imageDataSource.entities.values;
          viewerRef.current.selectedEntity = allEntities[nextIndex];

          if (fullscreen) {
            let temp = geojson.features[nextIndex].properties.images[0];
            for (const key in geojson.features[nextIndex].properties.images) {
              if (geojson.features[nextIndex].properties.images[key].camera_type === cam) {
                temp = geojson.features[nextIndex].properties.images[key];
              }
            }
            handleImageClick(temp);
          }
        } else {
          // reset
          setImageGeojsonSelected(geojson.features[0]);
          setImageGeojsonCounter(0);
          counterRef.current = 0;

          const allEntities = imageDataSource.entities.values;
          viewerRef.current.selectedEntity = allEntities[0];

          if (fullscreen) {
            let temp = geojson.features[0].properties.images[0];
            for (const key in geojson.features[0].properties.images) {
              if (geojson.features[0].properties.images[key].camera_type === cam) {
                temp = geojson.features[0].properties.images[key];
              }
            }
            handleImageClick(temp);
          }
        }
      }, cameraImageAllAutoPalyTimeout);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [cameraImageAllAutoPaly, cameraImageAllAutoPalyTimeout, cameraImageAllAutoPalySkip]);

  // Keyboard events
  const handleKeyDown = (event) => {
    if (!imageGeojsonMode) return;

    if (event.key === "ArrowRight" || event.keyCode === 39) {
      if (imageGeojson && imageGeojson.features[imageGeojsonCounter + 1]) {
        setImageGeojsonSelected(imageGeojson.features[imageGeojsonCounter + 1]);
        setImageGeojsonCounter(imageGeojsonCounter + 1);
        const allEntities = imageDataSource.entities.values;
        viewerRef.current.selectedEntity = allEntities[imageGeojsonCounter + 1];
        if (fullscreenImage) {
          let temp = imageGeojson.features[imageGeojsonCounter + 1].properties.images[0];
          for (const key in imageGeojson.features[imageGeojsonCounter + 1].properties.images) {
            if (imageGeojson.features[imageGeojsonCounter + 1].properties.images[key].camera_type == camera) {
              temp = imageGeojson.features[imageGeojsonCounter + 1].properties.images[key];
            }
          }
          handleImageClick(temp);
        }
      } else {
        setImageGeojsonSelected(imageGeojson.features[0]);
        setImageGeojsonCounter(0);
        const allEntities = imageDataSource.entities.values;
        viewerRef.current.selectedEntity = allEntities[0];
        if (fullscreenImage) {
          let temp = imageGeojson.features[0].properties.images[0];
          for (const key in imageGeojson.features[0].properties.images) {
            if (imageGeojson.features[0].properties.images[key].camera_type == camera) {
              temp = imageGeojson.features[0].properties.images[key];
            }
          }
          handleImageClick(temp);
        }
      }
    }
    if (event.key === "ArrowLeft" || event.keyCode === 37) {
      if (imageGeojson && imageGeojson.features[imageGeojsonCounter - 1]) {
        setImageGeojsonSelected(imageGeojson.features[imageGeojsonCounter - 1]);
        setImageGeojsonCounter(imageGeojsonCounter - 1);
        const allEntities = imageDataSource.entities.values;
        viewerRef.current.selectedEntity = allEntities[imageGeojsonCounter - 1];
        if (fullscreenImage) {
          if (fullscreenImage) {
            let temp = imageGeojson.features[imageGeojsonCounter - 1].properties.images[0];
            for (const key in imageGeojson.features[imageGeojsonCounter - 1].properties.images) {
              if (imageGeojson.features[imageGeojsonCounter - 1].properties.images[key].camera_type == camera) {
                temp = imageGeojson.features[imageGeojsonCounter - 1].properties.images[key];
              }
            }
            handleImageClick(temp);
          }
        }
      } else {
        setImageGeojsonSelected(imageGeojson.features[imageGeojson.features.length - 1]);
        setImageGeojsonCounter(imageGeojson.features.length - 1);
        const allEntities = imageDataSource.entities.values;
        viewerRef.current.selectedEntity = allEntities[imageGeojson.features.length - 1];
        if (fullscreenImage) {
          if (fullscreenImage) {
            let temp = imageGeojson.features[imageGeojson.features.length - 1].properties.images[0];
            for (const key in imageGeojson.features[imageGeojson.features.length - 1].properties.images) {
              if (imageGeojson.features[imageGeojson.features.length - 1].properties.images[key].camera_type == camera) {
                temp = imageGeojson.features[imageGeojson.features.length - 1].properties.images[key];
              }
            }
            handleImageClick(temp);
          }
          handleImageClick(imageGeojson.features[imageGeojson.features.length - 1].properties.images[0]);
        }
      }
    }
  };

  const handleImageClick = (image) => {
    setFullscreenImage(image);
    setCameraImageAllAutoPaly(false);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
    setIsPlay(false);
  };

  const handlePlayingCamera = () => {
    setIsPlay(!isPlay);
  };

  const [ignore, setIgnore] = useState("1");
  const items = [
    { label: "Normal", value: "1" },
    { label: "Skip 1 Frame", value: "2" },
    { label: "Skip 2 Frames", value: "3" },
    { label: "Skip 3 Frames", value: "4" },
    { label: "Skip 4 Frames", value: "5" },
    { label: "Skip 5 Frames", value: "6" },
  ];
  const [timeout, setTimeout] = useState(500);

  const intervalRef = useRef(null);
  const geojsonRef = useRef(imageGeojson);
  const counterRef = useRef(imageGeojsonCounter);
  const fullscreenRef = useRef(fullscreenImage);
  const cameraRef = useRef(camera);
  const ignoreRef = useRef(ignore);
  const timeoutRef = useRef(timeout);
  useEffect(() => {
    ignoreRef.current = ignore;
  }, [ignore]);
  useEffect(() => {
    timeoutRef.current = timeout;
  }, [timeout]);
  useEffect(() => {
    geojsonRef.current = imageGeojson;
  }, [imageGeojson]);

  useEffect(() => {
    counterRef.current = imageGeojsonCounter;
  }, [imageGeojsonCounter]);

  useEffect(() => {
    fullscreenRef.current = fullscreenImage;
  }, [fullscreenImage]);

  useEffect(() => {
    cameraRef.current = camera;
  }, [camera]);
  useEffect(() => {
    if (isPlay) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      const runInterval = () => {
        intervalRef.current = setInterval(() => {
          const geojson = geojsonRef.current;
          const counter = counterRef.current;
          const fullscreen = fullscreenRef.current;
          const cam = cameraRef.current;

          const step = parseInt(ignoreRef.current) || 1;
          const nextIndex = counter + step;

          if (geojson && geojson.features[nextIndex]) {
            setImageGeojsonSelected(geojson.features[nextIndex]);
            setImageGeojsonCounter(nextIndex);
            counterRef.current = nextIndex;

            const allEntities = imageDataSource.entities.values;
            viewerRef.current.selectedEntity = allEntities[nextIndex];

            if (fullscreen) {
              let temp = geojson.features[nextIndex].properties.images[0];
              for (const key in geojson.features[nextIndex].properties.images) {
                if (geojson.features[nextIndex].properties.images[key].camera_type === cam) {
                  temp = geojson.features[nextIndex].properties.images[key];
                }
              }
              handleImageClick(temp);
            }
          } else {
            // reset
            setImageGeojsonSelected(geojson.features[0]);
            setImageGeojsonCounter(0);
            counterRef.current = 0;

            const allEntities = imageDataSource.entities.values;
            viewerRef.current.selectedEntity = allEntities[0];

            if (fullscreen) {
              let temp = geojson.features[0].properties.images[0];
              for (const key in geojson.features[0].properties.images) {
                if (geojson.features[0].properties.images[key].camera_type === cam) {
                  temp = geojson.features[0].properties.images[key];
                }
              }
              handleImageClick(temp);
            }
          }
        }, timeoutRef.current);
      };

      runInterval();
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isPlay, timeout]);

  useEffect(() => {
    if (viewerRef.current && viewerRef.current && imageGeojsonSelected) {
      let offsetLon = 0.00003;
      let offsetLat = 0;
      if (viewerRef.current.scene.mode === SceneMode.SCENE2D) {
        offsetLon = (viewerRef.current.camera.positionCartographic.height * 0.00003) / 10;
      } else {
        offsetLon = (viewerRef.current.camera.positionCartographic.height * 0.00003) / 10;
        offsetLat = (viewerRef.current.camera.positionCartographic.height * 0.00009) / 10;
        offsetLat = offsetLat * -1;
      }
      flyToLocation(
        viewerRef.current,
        imageGeojsonSelected.geometry.coordinates[0] + offsetLon,
        imageGeojsonSelected.geometry.coordinates[1] + offsetLat,
        viewerRef.current.camera.positionCartographic.height,
      );
      selectEntityById(viewerRef.current, "gje-" + imageGeojsonCounter);
    }
  }, [imageGeojsonSelected, imageGeojsonCounter]);

  const moveCamera = (viewer, cameraPosition) => {
    // Extract coordinate and azimuth
    const [lon, lat, height] = cameraPosition.coordinate;
    const azimuth = cameraPosition.azimuth;

    // Convert azimuth from degrees to radians
    const heading = CesiumMath.toRadians(azimuth);

    // Pitch 0 means looking straight to the horizon
    const pitch = 0.0;

    // Roll is usually zero unless you want to tilt sideways
    const roll = 0.0;

    // Add 2.5 meters to height
    const adjustedHeight = height + 2.5;

    // Fly camera to position
    viewer.camera.setView({
      destination: Cartesian3.fromDegrees(lon, lat, adjustedHeight),
      orientation: {
        heading: heading,
        pitch: pitch,
        roll: roll,
      },
    });
  };

  const cameraOrder = ["F_30", "F_60", "FF_LH_120", "FF_RH_120", "RF_LH_120", "RF_RH_120", "F_120"];

  const sortedImages = cameraOrder.map((type) => {
    return imageGeojsonSelected?.properties?.images?.find((img) => img.camera_type === type) || null;
  });

  if (fullscreenImage) {
    setIsOpenAddonsMenu(false);
    return (
      <VStack position="fixed" top={0} left={0} width="100vw" height="100vh" zIndex={2000} bg="rgba(0, 0, 0, 0.3)" justifyContent="center" alignItems="flex-end" pr={"80px"}>
        <Box maxWidth="66%" maxHeight="90%" position="relative">
          <Image src={fullscreenImage.relpath} alt="Fullscreen Image" maxWidth="100%" maxHeight="100%" borderRadius="10px" objectFit="contain" />
          <Button color="white" position="absolute" bottom="10px" right="10px" fontSize="lg" bg="rgba(0, 0, 0, 0.8)" px="10px" borderRadius="5px" onClick={handlePlayingCamera}>
            {isPlay ? <LuPause /> : <LuPlay />}
          </Button>
          <Button color="white" position="absolute" top="10px" right="10px" fontSize="lg" bg="rgba(0, 0, 0, 0.8)" px="10px" borderRadius="5px" onClick={closeFullscreen}>
            <LuX />
          </Button>
          {isShowPointCloudMenu && (
            <Button
              color="white"
              position="absolute"
              bottom="60px"
              right="10px"
              fontSize="lg"
              bg="rgba(0, 0, 0, 0.8)"
              px="10px"
              borderRadius="5px"
              onClick={() => {
                moveCamera(viewerRef.current, {
                  coordinate: imageGeojsonSelected.geometry.coordinates,
                  azimuth: imageGeojsonSelected.properties.azimuth,
                });
                setBgImageUrl(fullscreenImage.relpath);
                setImageGeojsonMode(false);
                closeFullscreen();
              }}
            >
              Set Background
            </Button>
          )}

          <Text color="white" position="absolute" bottom="20px" left={"20px"} fontSize="lg" bg="rgba(0, 0, 0, 0.5)" px="10px" borderRadius="5px" direction={"ltr"}>
            {getCameraImageTypeName(fullscreenImage.camera_type)} - {new Date(imageGeojsonSelected?.properties?.timestamp_sec * 1000).toLocaleString()}
          </Text>
          <Menu.Root>
            <Menu.Trigger asChild>
              <Button position="absolute" bottom="10px" right="60px" fontSize="lg" bg="rgba(0, 0, 0, 0.8)" px="10px" borderRadius="5px">
                <LuFastForward />
              </Button>
            </Menu.Trigger>

            <Menu.Positioner>
              <Menu.Content minW="10rem">
                <Menu.RadioItemGroup value={ignore} onValueChange={(e) => setIgnore(e.value)}>
                  {items.map((item) => (
                    <Menu.RadioItem key={item.value} value={item.value}>
                      {item.label}
                      <Menu.ItemIndicator />
                    </Menu.RadioItem>
                  ))}
                </Menu.RadioItemGroup>
              </Menu.Content>
            </Menu.Positioner>
          </Menu.Root>
          <Menu.Root>
            <Menu.Trigger asChild>
              <Button position="absolute" bottom="10px" right="110px" fontSize="lg" bg="rgba(0, 0, 0, 0.8)" px="10px" borderRadius="5px">
                <LuTimer />
              </Button>
            </Menu.Trigger>

            <Menu.Positioner>
              <Menu.Content width={"20px"} pt={3}>
                <Field.Root>
                  <Box pos="relative" w="full">
                    <Input
                      className="peer"
                      placeholder=""
                      value={timeout}
                      onChange={(v) => {
                        if (v.target.value) {
                          setTimeout(parseInt(v.target.value));
                        } else {
                          setTimeout(0);
                        }
                      }}
                    />
                    <Field.Label css={floatingStyles}>Timeout (ms)</Field.Label>
                  </Box>
                </Field.Root>
              </Menu.Content>
            </Menu.Positioner>
          </Menu.Root>
        </Box>
      </VStack>
    );
  }

  if (imageGeojsonMode && imageGeojson && imageGeojsonSelected) {
    if (imageGeojsonSelected?.properties?.images?.length === 1 || Object.entries(geojsonImageCamera).filter(([key, value]) => value).length == 1) {
      return (
        <>
          {geojsonImageCamera[1] && (
            <VStack position={"fixed"} top={"13%"} right={"70px"} width={"33%"} zIndex={1005}>
              <Image
                src={imageGeojsonSelected?.properties?.images[0].relpath}
                alt={`Image`}
                cursor={"pointer"}
                height={"100%"}
                userSelect={"none"}
                borderRadius={"10px"}
                display={"inline-block"}
                onClick={() => {
                  handleImageClick(imageGeojsonSelected?.properties?.images[0]);
                  setCamera(imageGeojsonSelected?.properties?.images[0].camera_type);
                }}
              />
              <Text userSelect={"none"} position="absolute" bottom="10px" left="10px" color="white" bg="rgba(0, 0, 0, 0.5)" borderRadius="5px" px="5px" fontSize="sm">
                {getCameraImageTypeName(imageGeojsonSelected?.properties?.images[0].camera_type)}
              </Text>
              <Text userSelect={"none"} position="absolute" bottom="10px" right="10px" color="white" bg="rgba(0, 0, 0, 0.5)" borderRadius="5px" px="5px" fontSize="sm" direction={"ltr"}>
                {new Date(imageGeojsonSelected?.properties?.timestamp_sec * 1000).toLocaleString()}
              </Text>
              <CloseButton
                position="absolute"
                top="10px"
                right="20px"
                color="white"
                bg="rgba(0, 0, 0, 0.5)"
                borderRadius="5px"
                px="5px"
                fontSize="sm"
                onClick={() => {
                  let k = 1;
                  setGeojsonImageCamera((prevGeojsonImageCamera) => ({
                    ...prevGeojsonImageCamera,
                    [k]: false,
                  }));
                }}
              />
            </VStack>
          )}
        </>
      );
    } else if (imageGeojsonSelected?.properties?.images?.length === 2 || Object.entries(geojsonImageCamera).filter(([key, value]) => value).length == 2) {
      return (
        <VStack position="fixed" top="13%" right="70px" width="33%" height="74%" zIndex={1005} spacing={4}>
          {imageGeojsonSelected?.properties?.images?.map((image, index) => {
            const imageIndex = index + 1;
            const show = geojsonImageCamera[imageIndex];
            if (!show) return null;

            return (
              <VStack key={`${image.relpath}-${index}`} position="relative" width="fit-content" height="50%">
                <Image
                  src={image.relpath}
                  alt={`Image ${imageIndex}`}
                  cursor="pointer"
                  height="100%"
                  userSelect="none"
                  borderRadius="10px"
                  display="inline-block"
                  onClick={() => {
                    handleImageClick(image);
                    setCamera(image.camera_type);
                  }}
                />
                <Text userSelect="none" position="absolute" bottom="10px" left="10px" color="white" bg="rgba(0, 0, 0, 0.5)" borderRadius="5px" px="5px" fontSize="sm">
                  {getCameraImageTypeName(image.camera_type)}
                </Text>
                <Text userSelect="none" position="absolute" bottom="10px" right="10px" color="white" bg="rgba(0, 0, 0, 0.5)" borderRadius="5px" px="5px" fontSize="sm" direction={"ltr"}>
                  {new Date(imageGeojsonSelected?.properties?.timestamp_sec * 1000).toLocaleString()}
                </Text>
                <CloseButton
                  position="absolute"
                  top="10px"
                  right="20px"
                  color="white"
                  bg="rgba(0, 0, 0, 0.5)"
                  borderRadius="5px"
                  px="5px"
                  fontSize="sm"
                  onClick={() => {
                    setGeojsonImageCamera((prevGeojsonImageCamera) => ({
                      ...prevGeojsonImageCamera,
                      [imageIndex]: false,
                    }));
                  }}
                />
              </VStack>
            );
          })}
        </VStack>
      );
    } else if (imageGeojsonSelected?.properties?.images?.length === 3 || Object.entries(geojsonImageCamera).filter(([key, value]) => value).length == 3) {
      return (
        <VStack position="fixed" top="70px" right="70px" width="33%" height="100%" zIndex={1005}>
          {imageGeojsonSelected?.properties?.images?.map((image, index) => {
            const imageIndex = index + 1;
            const isVisible = geojsonImageCamera[imageIndex];
            if (!isVisible) return null;

            return (
              <VStack key={`${image.relpath}-${index}`} position="relative" width="fit-content" height="25%">
                <Image
                  src={image.relpath}
                  alt={`Image ${imageIndex}`}
                  cursor="pointer"
                  height="100%"
                  userSelect="none"
                  borderRadius="10px"
                  onClick={() => {
                    handleImageClick(image);
                    setCamera(image.camera_type);
                  }}
                />
                <Text userSelect="none" position="absolute" bottom="10px" left="10px" color="white" bg="rgba(0, 0, 0, 0.5)" borderRadius="5px" px="5px" fontSize="sm">
                  {getCameraImageTypeName(image.camera_type)}
                </Text>
                <Text userSelect="none" position="absolute" bottom="10px" right="10px" color="white" bg="rgba(0, 0, 0, 0.5)" borderRadius="5px" px="5px" fontSize="sm" direction={"ltr"}>
                  {new Date(imageGeojsonSelected?.properties?.timestamp_sec * 1000).toLocaleString()}
                </Text>
                <CloseButton
                  position="absolute"
                  top="10px"
                  right="20px"
                  color="white"
                  bg="rgba(0, 0, 0, 0.5)"
                  borderRadius="5px"
                  px="5px"
                  fontSize="sm"
                  onClick={() => {
                    setGeojsonImageCamera((prevGeojsonImageCamera) => ({
                      ...prevGeojsonImageCamera,
                      [imageIndex]: false,
                    }));
                  }}
                />
              </VStack>
            );
          })}
        </VStack>
      );
    } else {
      return (
        <SimpleGrid position="fixed" top="70px" templateRows="repeat(auto-fit, minmax(0, 1fr))" columns={2} dir="rtl" maxWidth={"60%"} height="calc(100vh - 140px)" right="70px" zIndex={1005}>
          {sortedImages.map((image, index) => {
            const imageIndex = index + 1;
            const show = geojsonImageCamera[imageIndex];

            return (
              <VStack key={index} position="relative" height="100%" width="fit-content" justifyContent="center" alignItems="center" bg={image ? "transparent" : "gray.800"} borderRadius="10px">
                {image && show ? (
                  <>
                    <Image
                      src={image.relpath}
                      alt={`Image ${imageIndex}`}
                      cursor="pointer"
                      height="100%"
                      userSelect="none"
                      borderRadius="10px"
                      display="inline-block"
                      onClick={() => {
                        handleImageClick(image);
                        setCamera(image.camera_type);
                      }}
                    />
                    <Text userSelect="none" position="absolute" bottom="10px" left="10px" color="white" bg="rgba(0, 0, 0, 0.5)" borderRadius="5px" px="5px" fontSize="sm">
                      {getCameraImageTypeName(image.camera_type)}
                    </Text>
                    <Text userSelect="none" position="absolute" bottom="10px" right="10px" color="white" bg="rgba(0, 0, 0, 0.5)" borderRadius="5px" px="5px" fontSize="sm" direction={"ltr"}>
                      {new Date(imageGeojsonSelected?.properties?.timestamp_sec * 1000).toLocaleString()}
                    </Text>
                    <CloseButton
                      position="absolute"
                      top="10px"
                      right="20px"
                      color="white"
                      bg="rgba(0, 0, 0, 0.5)"
                      borderRadius="5px"
                      px="5px"
                      fontSize="sm"
                      onClick={() => {
                        setGeojsonImageCamera((prev) => ({
                          ...prev,
                          [imageIndex]: false,
                        }));
                      }}
                    />
                  </>
                ) : null}
              </VStack>
            );
          })}
        </SimpleGrid>
      );
    }
  } else {
    return null;
  }
};

export default ImageGeojsonBoxes;
